import React from 'react';
import { useEffect, useState } from 'react';
import ProfilePicWithDetails from 'Components/Client/Cases/CaseDetails/ProfilePicWithDetails';
import { getCaseType } from 'Utils';
import { X } from 'lucide-react';
import useIsMobile from 'Hooks/useIsMobile';


function TeamUpDetailsModalContent({
    currentProf,
    showContact = false,
    onClose,
    isModal = true,
    showButtons = false,
    buttonDiv = null,
}) {
    const [profData, setProfData] = useState({
        
       
        "Designation" : "legalType",
        "Company" : "company",
        
        "In Industry for" : "experience",
        "URL" : "lawFirmLink",
        "Case Preference": "casePref",
        "State Preference" : "statePref",
    });
    useEffect(() => {
        if(!currentProf?.isUserFunder)
        {
            setProfData({
                
                "Phone Number" : "phoneNumber",
                "Email" : "email",
                "Designation" : "legalType",
                "Company" : "company",
                "Experience" : "experience",
                "Law Firm URL" : "lawFirmLink",
                "Case Preference": "casePref",
                "State Preference" : "statePref",
            });
        }}, [currentProf]);
    
    useEffect(() => {
        if(showContact && currentProf?.isUserFunder)
        {
            setProfData((prev) => {
                return {
                    
                    "Email" : "email",
                    ...prev,
                }
            })
        }
    }, [showContact])
  const isMobile = useIsMobile();
  const valueOf = (label, key) => {
    const v = currentProf?.[key];
    if (Array.isArray(v)) {
      if (v.length === 0) return <span className='italic font-normal text-navy/[.55]'>All {label?.split(" ")[0]?.toLowerCase()}s</span>;
      return v.map((x) => (key === "casePref" ? getCaseType(x) : x)).join(', ');
    }
    if (!v) return <span className='text-navy/[.4] font-normal'>—</span>;
    if (key === "lawFirmLink") return <a target="_blank" rel="noopener noreferrer" href={/^https?:\/\//i.test(v) ? v : "https://" + v} className='text-brass underline [overflow-wrap:anywhere]'>{v}</a>;
    if (key === "email") return <a href={"mailto:" + v} className='text-navy underline [overflow-wrap:anywhere]'>{v}</a>;
    if (key === "phoneNumber") return <a href={"tel:" + v} className='text-navy underline'>{v}</a>;
    return <>{v}{key === "experience" ? " years" : ""}</>;
  };
  return (
    <div className='font-plexsans'>
      {isModal &&
        <div className='flex items-center justify-between py-4 px-5 border-b border-navy/[.1]'>
          <span className='font-spectral font-normal text-[18px] leading-[1.2] text-navy'>{currentProf?.isUserFunder ? 'Funder details' : 'Attorney details'}</span>
          <X onClick={onClose} className="cursor-pointer text-navy w-[18px] h-[18px]" />
        </div>}
      <div className={`grid ${isMobile ? 'grid-cols-[minmax(0,1fr)]' : 'grid-cols-[220px_minmax(0,1fr)]'}`}>
        <div className={`bg-ivory flex justify-center items-start py-2 ${isMobile ? 'border-b border-navy/[.08]' : 'border-r border-navy/[.08]'}`}>
          <ProfilePicWithDetails currentProf={currentProf} picSize={isModal ? "l" : null} />
        </div>
        <div className={`min-w-0 ${isMobile ? 'pt-1.5 px-4 pb-4' : 'pt-2 px-[22px] pb-[18px]'}`}>
          {Object.entries(profData).map(([label, key]) => (
            <div key={label} className='flex justify-between gap-4 py-2.5 border-b border-navy/[.08]'>
              <span className='font-plexsans font-normal text-[13px] leading-[1.4] text-navy/[.6] flex-none'>{label}</span>
              <span className='font-plexsans font-semibold text-[13px] leading-[1.4] text-navy text-right min-w-0 [overflow-wrap:anywhere]'>{valueOf(label, key)}</span>
            </div>
          ))}
          {showButtons && buttonDiv &&
            <div className='mt-4 flex gap-2.5 flex-wrap'>{buttonDiv}</div>}
        </div>
      </div>
    </div>
  )
}

export default TeamUpDetailsModalContent
